(function () {
    'use strict';

    var HASH_KEY = 'tool-handoff';
    var pendingText = null;
    var pendingAction = null;

    function bytesToBase64(bytes) {
        var binary = '';
        var chunkSize = 8192;
        for (var start = 0; start < bytes.length; start += chunkSize) {
            var end = Math.min(start + chunkSize, bytes.length);
            for (var index = start; index < end; index++) {
                binary += String.fromCharCode(bytes[index]);
            }
        }
        return window.btoa(binary)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    function encode(value) {
        var text = String(value || '');
        if (typeof window.TextEncoder === 'function') {
            return bytesToBase64(new window.TextEncoder().encode(text));
        }

        // TextEncoder is missing only in old Safari. encodeURIComponent gives
        // btoa the same UTF-8 bytes without depending on browser storage.
        return window.btoa(window.unescape(encodeURIComponent(text)))
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    function decode(value) {
        var payload = String(value || '').replace(/-/g, '+').replace(/_/g, '/');
        payload += '==='.slice((payload.length + 3) % 4);
        var binary = window.atob(payload);

        if (typeof window.TextDecoder === 'function') {
            var bytes = new Uint8Array(binary.length);
            for (var index = 0; index < binary.length; index++) {
                bytes[index] = binary.charCodeAt(index);
            }
            return new window.TextDecoder().decode(bytes);
        }

        var escaped = '';
        for (var offset = 0; offset < binary.length; offset++) {
            escaped += '%' + ('0' + binary.charCodeAt(offset).toString(16)).slice(-2);
        }
        return decodeURIComponent(escaped);
    }

    function makeUrl(href, action, text) {
        var url = new URL(href, window.location.href);
        url.searchParams.set(action, '1');
        url.hash = HASH_KEY + '=' + encode(text);
        return url.toString();
    }

    // Capture at script evaluation time. The helper is loaded near the start of
    // <head>, so analytics and later page scripts never see the text in the URL.
    (function capture() {
        var params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        var payload = params.get(HASH_KEY);
        if (!payload) return;

        try {
            pendingText = decode(payload);
        } catch (error) {}

        var search = new URLSearchParams(window.location.search);
        pendingAction = search.has('check') ? 'check'
            : search.has('humanize') ? 'humanize'
            : search.has('grammar') ? 'grammar' : null;

        // The fragment never reaches the server, and it should not remain in
        // the address bar or browser history after the destination reads it.
        var clean = new URL(window.location.href);
        if (pendingAction) clean.searchParams.delete(pendingAction);
        clean.hash = '';
        window.history.replaceState(null, '', clean.pathname + clean.search);
    }());

    function requested(action) {
        return pendingAction === action;
    }

    function consume(action) {
        if (pendingText === null || (pendingAction && pendingAction !== action)) return null;
        var text = pendingText;
        pendingText = null;
        return text;
    }

    window.ToolHandoff = {
        makeUrl: makeUrl,
        consume: consume,
        requested: requested
    };
}());
